import { Link } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { City } from "../city/type";

export default function CityDetailButton(props: GridCellParams<City, any>) {
    return <Link component={RouterLink} to={props.row.cityCode}>Detay</Link>
}